const localeOpts = { sensitivity: "base" };

export const sortEquipementsByNom = (list = []) =>
  [...list].sort((a, b) =>
    (a?.nom || "").localeCompare(b?.nom || "", "fr", localeOpts)
  );

export const sortForfaitEquipementsByNom = (list = []) =>
  [...list].sort((a, b) =>
    (a?.equipement?.nom || "").localeCompare(
      b?.equipement?.nom || "",
      "fr",
      localeOpts
    )
  );
